export const RATING = {
    GET_RATING: "rating/GET_RATING",
    CREATE_RATINGTRANSACTION: "rating/CREATE_RATINGTRANSACTION",
};
